import { HttpRequestMethods } from "../request/constants";

import { ILifecycle } from "../types";

export function apiType(applicationName: string, controller: string, method: HttpRequestMethods): string {
  return `${applicationName}_${controller.toUpperCase()}_${method.toUpperCase()}`;
}

export function requestLifecycleFromType(type: string): ILifecycle {
  return {
    PENDING: `${type}_PENDING`,
    RESOLVED: `${type}_RESOLVED`,
    REJECTED: `${type}_REJECTED`,
  };
}
